import { connect } from "react-redux";
import DetailSearch from "../components/DetailSearch/DetailSearch";
import { fetchDetailSearch, fetchDetailSearchCount, fetchDataType  } from "../actions/detailsearch";

const mapStateToProps = (state) => ({
    user: state.login.user,
    menuData: state.menu.menuData,
    isFetching: state.detailsearch?.isFetching || false,
    isFetchingCount: state.detailsearch.isFetchingCount,
    error: state.detailsearch?.error || null,
    data: state.detailsearch?.data || [],
    headers: state.detailsearch?.headers || [],
    count: state.detailsearch?.count || 0,
    keys: state.detailsearch.keys,
    document_category: state.detailsearch?.document_category || [],
    document_type: state.detailsearch?.document_type || [],
});

const mapDispatchToProps = {
    fetchDetailSearch,
    fetchDetailSearchCount,
    fetchDataType 
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailSearch);
